import React from 'react';
import { connect } from 'react-redux';
import { toggleShowSidebarContainer, toggleShowTasksSidebar } from 'actions';
import { Container } from '../';
import { Link } from 'react-router';
import { TasksSidebar } from 'components';

import { ClientDetails, DashboardProfile } from '../'

class SidebarContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    	side_bar_open : false
    }

    this.handleClickSidbar = this.handleClickSidbar.bind(this);
    this.handleClickTasksSidebarToggle = this.handleClickTasksSidebarToggle.bind(this);
  }

  handleClickSidbar() {
  	if(this.state.side_bar_open === false) {
		if(!this.props.ui.show_sidebar_container) {
  			this.props.toggleShowSidebarContainer(true)
  		}
  		this.setState({side_bar_open : true})
  		$('html').addClass(' inner-menu-opened')
		}
    else {
  		this.setState({side_bar_open : false})
  		$('html').removeClass(' inner-menu-opened')
    }
  }
  handleClickTasksSidebarToggle() {
    this.props.toggleShowTasksSidebar();
  }

  render() {
    return (
      <section role="main" className="content-body outer-menu-container">
        <header className="page-header hidden-xs">
          <h2>{this.props.title}</h2>
          <div className="right-wrapper pull-right">
            <ol className="breadcrumbs">
              <li>
                <a href="#/">
                  <i className="fa fa-home"></i>
                </a>
              </li>
              <li><span>{this.props.title}</span></li>
            </ol>
            <div
              className='sidebar-right-toggle'
              data-open='sidebar-right'
              onClick={this.handleClickTasksSidebarToggle}
              >
              <i className='fa fa-thumb-tack tasks-sidebar-toggle' />
            </div>
          </div>
        </header>
        <section className="content-with-menu media-gallery">
          <div className="content-with-menu-container">
            <div className="inner-menu-toggle">
              <a className="inner-menu-expand" data-open="inner-menu" onClick={this.handleClickSidbar}>
                Show Bar <i className="fa fa-chevron-right"></i>
              </a>
            </div>
            {(() => {
            	if(this.props.ui.show_sidebar_container) {
            		return (
            			<menu id="content-menu" className="inner-menu animated fadeInLeftBig" role="menu">
			              <div className="nano">
					            <div className="nano-content">
				                <div className="inner-menu-toggle-inside">
				                  <a className="inner-menu-collapse" onClick={this.handleClickSidbar}>
				                    <i className="fa fa-chevron-up visible-xs-inline"></i><i className="fa fa-chevron-left hidden-xs-inline"></i> Hide Bar
				                  </a>
				                  <a className="inner-menu-expand" data-open="inner-menu" onClick={this.handleClickSidbar}>
				                    Show Bar <i className="fa fa-chevron-down"></i>
      	                  </a>
      	                </div>
				                <div className="inner-menu-content">
				                  <div className="sidebar-widget m-none">
      	                  	{(() => {
      	                  		if(this.props.is_client)
      			                  	return <ClientDetails client={this.props.client} />
      			                  else if(this.props.is_user) {
      			                  	return <DashboardProfile user={this.props.users.user} />
        			                  }
        	                  	})()}
        	                  </div>
  	                        <hr className="short" />
  				                  <div className="widget-content">
  				                    <ul className="list-unstlyed mg-folders">
      	                      {this.props.menuItems.map((item, idx) => {
      	                        return (
      	                          <li key={idx}>
  			                            <Link activeClassName="nav-active" className="menu-item" to={item.path}>
      	                              <i className={item.iconClass}></i> {item.label}
      	                            </Link>
      	                          </li>
      	                        )
      	                       })}
      	                    </ul>
      	                  </div>
                        </div>
                      </div>
                    </div>
                  </menu>
                )
              }
            })()}
            <div className='inner-body mg-main'>
              <TasksSidebar />
              {this.props.children}
            </div>
          </div>
        </section>
      </section>
    );
  }
}

let mapStateToProps = ({ client, users, ui }) => ({ client, users, ui });

export default connect(mapStateToProps, { toggleShowSidebarContainer, toggleShowTasksSidebar })(SidebarContainer);



// WEBPACK FOOTER //
// ./src/browser/components/ui/sidebarContainer.js